import AddIcon from '@material-ui/icons/Add';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useState } from 'react';
import { ReduxState, useTranslate } from 'react-admin';
import { useSelector } from 'react-redux';
import MenuButtonActions, { MenuItemType } from '../../../commons/menuButtonActions';
import { CustomReducerState } from '../../../redux/reducers';
import { getCategorySelected } from '../../../redux/reducers/categories';
import { GroupMetadataAvatarType } from '../../../utils/types';
import CreateForm from './create';
import DeleteForm from './delete';
import EditForm from './edit';
import {
    ROLE_CREATE_GROUP_OBJECT_TYPE,
    ROLE_DELETE_GROUP_OBJECT_TYPE,
    ROLE_READ_GROUP_OBJECT_TYPE,
    ROLE_UPDATE_GROUP_OBJECT_TYPE,
} from '../../../utils/ROLES';

const SimpleActionMenu = () => {
    const translate = useTranslate();
    const [showCreateForm, setShowCreateForm] = useState<boolean>(false);
    const [showEditForm, setShowEditForm] = useState<boolean>(false);
    const [showDeleteForm, setShowDeleteForm] = useState<boolean>(false);
    const [menuState, setMenuState] = useState(false);

    const selected: GroupMetadataAvatarType | undefined = useSelector((state: CustomReducerState & ReduxState) =>
        getCategorySelected(state)
    );

    const showCreateFormFn = () => {
        setShowCreateForm(true);
    };

    const showEditFormFn = () => {
        setShowEditForm(true);
    };

    const showDeleteFormFn = () => {
        setShowDeleteForm(true);
    };

    const menuActions: MenuItemType[] = [
        {
            icon: <AddIcon />,
            text: translate('app.menuActions.create'),
            onClick: showCreateFormFn,
            disabled: false,
            roles: [ROLE_CREATE_GROUP_OBJECT_TYPE],
        },
        {
            icon: <BorderColorIcon />,
            text: translate('app.menuActions.edit'),
            onClick: showEditFormFn,
            disabled: !selected,
            roles: [ROLE_UPDATE_GROUP_OBJECT_TYPE],
        },
        {
            icon: <DeleteIcon />,
            text: translate('app.menuActions.archive'),
            onClick: showDeleteFormFn,
            disabled: !selected,
            roles: [ROLE_DELETE_GROUP_OBJECT_TYPE],
        },
    ];

    const handleToggle = () => {
        setMenuState(!menuState);
    };

    return (
        <div>
            <MenuButtonActions
                buttonLabel={translate('app.menuActions.title')}
                overwriteButtonLabel
                menuActions={menuActions}
                menuState={menuState}
                onButtonClick={handleToggle}
            />

            {showCreateForm && <CreateForm open={true} handleClose={() => setShowCreateForm(false)} />}

            {showEditForm && selected && (
                <EditForm selected={selected} open={true} handleClose={() => setShowEditForm(false)} />
            )}

            {showDeleteForm && selected && (
                <DeleteForm selected={selected} open={true} handleClose={() => setShowDeleteForm(false)} />
            )}
        </div>
    );
};

export default SimpleActionMenu;
